<template>
	<div class="cat-animator cover">
		<transition
			:appear="shouldAnimateAppear()"
			appear-class="grow-enter"
			appear-active-class="grow-enter-active"
			appear-to-class="grow-to"
			leave-active-class="shrink-leave-active"
			leave-to-class="shrink-leave-to"
		>
			<BaseAnimation
				v-if="hasBaseAnimation"
				:class="baseAnimationClass"
				:state="state"
			/>
		</transition>
		<component
			v-show="hasHelper"
			:is="helper"
			:class="breed.name"
			:name="breed.name"
			:walkDuration="breed.walk_animation.duration"
			:walkDistance="walkDistance"
			:state="state"
			:initialState="initialState"
			@spawnComplete="completeSpawn"
			@walkComplete="completeEntrance"
			@completedPoof="feedingComplete"
			@angelCreated="angelCreated"
			@deathComplete="completeDeath"
		/>
	</div>
</template>

<script>
import BaseAnimation from '@/components/cat/BaseAnimation';
import Walk from '@/components/cat/Walk';
import Poof from '@/components/cat/Poof';
import Rays from '@/components/cat/Rays';
import Angel from '@/components/cat/Angel';

export default {
	name: 'CatAnimationHelper',
	components: {
		BaseAnimation,
		Walk,
		Poof,
		Angel,
		Rays,
	},
	props: ["state", "breed", "walkDistance", "initialState"],
	data() {
		return {
			helperOverride: true,
			isSpawning: true,
			walkComplete: false,
		};
	},
	computed: {
		baseAnimationClass() {
			return this.initialState === "walking" && !this.walkComplete ? "" : this.breed.name;
		},
		hasBaseAnimation() {
			return this.state !== 'walking' && this.state !== 'satisfied' && this.state !== 'unssatisfied';
		},
		hasHelper() {
			return this.isSpawning || (this.state !== "fed" && this.state !== "starvation" && this.helperOverride);
		},
		helper() {
			const states = {
				Rays: this.isSpawning,
				Poof: this.state === "satisfied" || this.state === "unsatisfied",
				Walk: this.state === "walking",
				Angel: (this.state === "death" && this.initialState !== "death") || this.initialState === "angel",
			};
			return Object.keys(states).find(state => states[state]);
		},
	},
	methods: {
		shouldAnimateAppear() {
			return this.initialState !== "walking"
				&& this.initialState !== "death"
				&& this.initialState !== "angel";
		},
		completeEntrance() {
			this.walkComplete = true;
			this.$emit("walkComplete");
		},
		feedingComplete() {
			this.$emit("feedingComplete");
		},
		angelCreated() {
			this.helperOverride = false;
		},
		completeDeath() {
			this.$emit("hasDied");
		},
		completeSpawn() {
			this.$store.commit("decrementRemainingSpawns");
			this.isSpawning = false;
		},
	},
};
</script>

<style lang="scss" scoped>
	.cat-animation {
		@include cover;
	}

	.cat.walking .base-animation {
		visibility: hidden;
	}

</style>



// WEBPACK FOOTER //
// src/components/cat/CatAnimator.vue